import styled from "styled-components";
import { removeWords } from "./helpers/utils";

const ContainerPage = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding-top: 20px;
  flex-direction: column;
`;

const Line = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 16px;
`;

type InputProps = {
  characters: number;
}

const charSize = 16; // in pixels

const Input = styled.input<InputProps>`
  height: 20px;
  width: ${props => `${props.characters * charSize}px`};
  outline: none;
  border: none;
  border-bottom: solid 2px white;
  color: white;
  margin-top: 3px;
  font-size: 16px;
  background: transparent;
`;

var musicText = [
  "Ayy, CZR, you did a mazza still",
  "Gotcha",
  "Grrt, ayy, mh-mm, ayy, ayy, uh, yo",
  "",
  "Like my wap back filled to the brim? ",
  "Shake that back, rah, you been in the gym?",
  "We don't need money like Kanye",
  "Becah we still take Kim",
  "Body look cute, sei bem",
  "Look at that view, nós tem",
  "Who's that yute? Ninguém",
  "Put him on mute ",
  "",
  "Pelos acesso, palmeando tudo",
  "Correndo de Nike, fazendo dinheiro",
  "Eu quase não peço, mano, eu tenho tudo",
  "Pergunta quem manda no Rio de Janeiro",
  "Subi sem porte, sem Glock",
  "Sem G3, Fal, sem AK",
  "Nunca foi sorte, medo da mortе",
  "Aqui nós não tem, manda tentar",
  "Barulho de tiro , sirеne",
  "Cachorro latindo, não deve, não teme",
  "Bigode fino, madame treme",
  "Blusa de time, sempre de Kenner",
  "",
  "Mh-mm, you know it's only millis in my bank account ",
  "RJ city, criminal ",
  "Tion Wayne , L7 ",
  "Like a AK-47, bow, bow, bow",
  "Son of City of God, man ",
  "Yo, don't touch my fam ",
  "Don't touch my fam ",
  "You don't know my gang",
  "",
  "Like my wap back filled to the brim? ",
  "Shake that back, rah, you been in the gym?",
  "We don't need money like Kanye",
  "Becah we still take Kim",
  "Body look cute, sei bem",
  "Look at that view, nós tem",
  "Who's that yute? Ninguém",
  "Put him on mute ",
  "",
  "Why everybody hate like Chris? ",
  "Becah my rocks are messy ",
  "My young boy tucked with a Smith ",
  "Becah he just wan' slap it",
  "Even though I'm rich, man, I just done a shavin' ",
  "Where'd you think I got bad habits? ",
  "If she got bum and the breasts, that's package",
  "Swear that I need a gyal from Paris ",
  "Where're you from? What's your ends? ",
  "Don't pretend, back the skeng ",
  "I got Brazilian girls sayin', Peng ",
  "And when they come, better bring some friends ",
  "If she got a big back, I rate",
  "If money make you move your arse, then shake",
  "Better mind out that your heart don't break",
  "T-Wayne, you know my name hold weight",
  "Saw a guy that I robbed in prison ",
  "But still I'm good ",
  "Really at a bond like double-0-7 ",
  "'Til they shit got took",
  "All these million records I'm sellin', but I really ain't left my hood ",
  "Even though I got rich off this music, still we will get 'em shook ",
  "Yo, fifteen bags for some trainers",
  "Fifty bag for the day-date",
  "Can't believe I went jail doing basic ",
  "Hundred plus for the spaceship ",
  "I can't risk my status, so we show the 'matic upgraded ",
  "Pree the way batty just shake, outrageous ",
  "She know gyal with the big back, my favourite",
  "",
  "Like my wap back filled to the brim? ",
  "Shake that back, rah, you been in the gym?",
  "We don't need money like Kanye",
  "Becah we still take Kim",
  "Body look cute, sei bem",
  "Look at that view, nós tem",
  "Who's that yute? Ninguém",
  "Put him on mute ",
  "Like my wap back filled to the brim? ",
  "Shake that back, rah, you been in the gym?",
  "We don't need money like Kanye",
  "Becah we still take Kim",
  "Body look cute, sei bem",
  "Look at that view, nós tem",
  "Who's that yute? Ninguém",
  "Put him on mute ",
  "",
  "Ayy, CZR, you did a mazza still",
  "Gotcha",
];

const App = () => {
  const lines = removeWords(musicText, 30);
  
  const verify = () => {
    // when edit chantge the color to original  
    // word with the wrong or correct type
    // case incenstiive and accent icensitive
    
  }

  return <ContainerPage>{lines.map((line) => {
    return (<Line>
      {line.map(word => word.isEmpty ? <Input characters={word.text.length}></Input> : <p>{word.text}</p>)}
    </Line>)
  })}
  
  <button onClick={() => verify()}></button></ContainerPage>;
};

export default App;
